








import Vue from "vue";
import Component from "vue-class-component";
import { MediaQuery as MQ } from "@/MediaQuery";
import { getModule } from "vuex-module-decorators";
import { NavModule } from "@/store";
import ActivityComponent from "@/components/ActivityComponent.vue";

@Component({
  components: {
    ActivityComponent
  }
})
export default class BankTransactions extends Vue {
  navStore: NavModule = getModule(NavModule, this.$store);
  MQ = MQ;

  // Lifecyle functions //
  mounted() {
    // console.log('transactions mounted')
    if (MQ.sm) {
      this.navStore.setNavBarTitle(this.$tc("nav.bank.transactions"));
    }
  }
  beforeDestroy() {
    // console.log('transactions beforedestroy')
    this.navStore.setNavBarTitle("");
  }
}
